import { useMutation } from '@tanstack/react-query';
import { deleteOfferFile, uploadFile } from 'api/files/filesApi';
import { FileBody } from 'api/files/types';

import { FormFile } from 'components/Attachments/types';

import { useClientOffer } from './useClientOffer';

type FileContext = Pick<FileBody, 'offer' | 'policy'>;

export function useUploadClientOfferFile(fileContext?: FileContext) {
  const { offer } = useClientOffer();
  return useMutation(async (file: File) => {
    if (!offer?.id) throw new Error('No offer provided');
    const context = fileContext || { offer: offer.id };

    return uploadFile({ file: file, ...context });
  });
}

export function useDeleteClientOfferFiles() {
  return useMutation(async (files: FormFile[]) => {
    return Promise.all(files.map((f) => deleteOfferFile(f.id)));
  });
}
